<template>

  <el-row :gutter="5">
    <el-col :span="8"><h2 class="heading" style="text-align:right;">My Payments List</h2></el-col>
    <el-col :span="12" style="padding-top:20px; padding-left:20px;">
        <span class="label">Purpose</span>
        <el-input v-model="purpose" style="width:120px;margin-right:5px;"/> 
        <el-button @click="queryByPurpose">Go</el-button>

        <span class="label">PayTo</span>
        <el-input v-model="payTo" style="width:120px;margin-right:5px;"/> 
        <el-button @click="queryByPayTo">Go</el-button>

        <span class="label">ETFs</span>
        <el-select v-model="etf" @change="selectETF" style="width:120px;" clearable>
            <el-option v-for="etf in ETFs" :key="etf" :label="etf" :value="etf"></el-option>
        </el-select>
    </el-col>
    <el-col :span="4" style="padding-top:20px;">
        <el-button v-if="global.hasRight('payments', 'approver') || global.hasRight('payments', 'statistician')" 
            @click="$router.push('/payment/allPaymentList')">
            <el-icon><Search/></el-icon> &nbsp; All Payments List</el-button>
        <el-button style="margin-left:20px;" @click="$router.push('/payment/editPayment')" >
            <el-icon><Plus/></el-icon> &nbsp; Add Payment</el-button>
    </el-col>
  </el-row>

  <el-table :data="paymentList" height="90%" style="width:95%; margin:15px auto;" :row-class-name="tableRowClassName" 
        :default-sort="{ prop: prop, order: order }" @sort-change="sortChange">
    <el-table-column prop="id" label="ID" width="60" align="center" sortable/>
    <el-table-column prop="category" label="Category" sortable="custom" width="120">
        <template #default="scope">
            {{scope.row.category == 'Others' ? scope.row.category2 : scope.row.category}}
        </template>
    </el-table-column>
    <el-table-column prop="purpose" label="Purpose" width="200" sortable="custom" />
    <el-table-column prop="requester" label="Requester" width="100"/>
    <el-table-column prop="requestDate" label="Request Date" align="center" width="130" sortable="custom"/>
    <el-table-column prop="payTo" label="Pay To"  width="200" sortable="custom" />
    <el-table-column prop="relatedETFs" label="RelatedETFs" width="150" sortable="custom"/>
    <el-table-column prop="paymentDate" label="Payment Date" align="center" width="140" sortable="custom"/>
    <el-table-column prop="amount" label="Amount(Ccy)" align="right" width="140" sortable="custom">
        <template #default="scope">
            {{global.number_format(scope.row.amount, 2)}} <span style="font-size:0.8em">{{scope.row.currency}}</span>
        </template>
    </el-table-column>
    <el-table-column prop="status" label="Status" align="center"  sortable="custom"/>
    <el-table-column prop="status" label="Action" align="center" width="200">
        <template #default="scope">
            <a href="" v-if="scope.row.canApprove" @click.prevent="$router.push('/payment/viewPayment?code=' + scope.row.idMD5)" title="Approve" class="op">
                Approve
            </a>
            <a href="" v-if="scope.row.canConfirm" @click.prevent="$router.push('/payment/viewPayment?code=' + scope.row.idMD5)" title="Confirm" class="op">
                Confirm
            </a>
            <a href="" v-if="scope.row.canSignOff" @click.prevent="$router.push('/payment/viewPayment?code=' + scope.row.idMD5)" title="Signoff" class="op">
                Signoff
            </a>
            <a href="" v-if="scope.row.canReview" @click.prevent="$router.push('/payment/viewPayment?code=' + scope.row.idMD5)" title="Review" class="op">
                Review
            </a>
            <a href="" v-if="scope.row.canReview2" @click.prevent="$router.push('/payment/viewPayment?code=' + scope.row.idMD5)" title="Review2" class="op">
                Review2
            </a>
            <a href="" v-if="scope.row.canUpdate" 
                @click.prevent="$router.push('/payment/editPayment?code=' + scope.row.idMD5)" title="Update" class="op">
                Update
            </a>
            <el-icon v-else-if="scope.row.status=='new' || scope.row.status=='wait-confirm' || scope.row.status=='wait-review' || scope.row.status=='wait-approve' " 
                :size="16" @click="$router.push('/payment/editPayment?code=' + scope.row.idMD5)" style="cursor:pointer;" title="Edit">
                <edit />
            </el-icon>
            <el-icon v-if="!scope.row.canConfirm" :size="16" @click="$router.push('/payment/viewPayment?code=' + scope.row.idMD5)" style="cursor:pointer" title="View details">
                <document />
            </el-icon>
            <el-icon :size="16" @click="$router.push('/payment/editPayment?code=' + scope.row.idMD5+'&action=copy')" style="cursor:pointer" title="Copy to new request">
                <DocumentCopy />
            </el-icon>
            <el-icon v-if="scope.row.status=='new'" :size="16" @click="deletePayment(scope.row.idMD5)" style="cursor:pointer" title="Delete">
                <delete />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>
  <el-pagination background layout="prev, pager, next" :total="page.rowCount" :page-size="page.pageSize" :current-page="page.currPage"
    @current-change="getPaymentList" style="justify-content: center;"></el-pagination>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Document, Edit , Delete, DocumentCopy, Plus, Search } from '@element-plus/icons-vue'

export default {
    components: {
        Document, Edit, Delete, DocumentCopy, Plus, Search
    },
    data() {
        return {
            orderObj : {prop: "id", order: "descending"},
            paymentList: [],
            page: {currPage: 1},
            errMsg: '',
            global,
            ETFs: ['All', '2803', '3173', '2810', '3181', '2804', '3077', '9078', '2817', '9177', '3001', '3151', '3411', '3453', '9159', '3478'],
            etf: null,
            payTo: null,
            purpose: null,
        }
    },
    mounted() {
        this.global.index = "payment";
        this.getPaymentList(1);
    },
    methods: {
        async getPaymentList(pageNo) {
            this.page.currPage = pageNo;
            let data = {prod: this.orderObj.id, order: this.orderObj.order};
            data["pageNo"] = pageNo;
            if (this.etf) data.etf = this.etf;
            if (this.payTo) data.payTo = this.payTo;
            if (this.purpose) data.purpose = this.purpose;
            let result = await AXIOS("/payment/myPaymentList", data);
            if (result.success) {
                this.paymentList = result.data.list;
                this.page = result.data.page;
            } else {
                this.errMsg = result.errMsg;
            }
        },
        tableRowClassName(scope) {
            return (scope.row.status == "approved" || scope.row.status == "rejected") ? "" : scope.row.status;
        },
        selectETF() {
            console.log("enter selectETF()..." + this.etf);
            this.payTo = null;
            this.purpose = null;
            this.getPaymentList(1);
        },
        queryByPayTo() {
            this.etf = null;
            this.purpose = null;
            this.getPaymentList(1);
        },
        queryByPurpose() {
            this.etf = null;
            this.payTo = null;
            this.getPaymentList(1);
        },
        sortChange(orderObj) {
            this.orderObj = orderObj;
            this.page.currPage = 1;
            this.getPaymentList(1);
        },

        deletePayment(id) {
            ElMessageBox.confirm(
                'Are you sure want to delete this payment?',  'Warning', {
                    confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning',
                }
            ).then(async () => {
                let result = await AXIOS("/payment/deletePayment", {id : id});
                if (result.success) {
                    this.paymentList.splice(this.paymentList.findIndex(e => e.idMD5 == id), 1);
                    ElMessage({
                        message: 'Deleted payments successfully!',
                        type: 'success',
                    });
                } else {
                    ElMessage({
                        message: result.errMsg,
                        type: 'error',
                    });
                }
            });
        }
    }
}
</script>

<style>

</style>